/** @format */
import Link from 'next/link';

const Categories = props => {
	const {category, styles, state, dispatch} = props;
	const getItem = (item, key) => {
		return (
            <li
				onClick={() =>
					key === 'cat' ? changeCategory(item) : changeSubCategory(item)
				}
				key={item._id}
				className={
					key === 'cat'
						? item.slug === state.activeCategory
							? styles.activeItem
							: ''
						: item.slug === state.activeSubChildren
						? styles.activeItem
						: ''
				}
			>
                <Link
                    href={
						key === 'cat'
							? `/brands/${item.slug}?alpha=A`
							: `/brands/${state.activeCategory}?category=${item.slug}&alpha=A`
					}>
                    <div className={styles.brandTitle}>{item.Name}</div>
                </Link>
            </li>
        );
	};

	const changeCategory = item => {
		if (item.slug !== state.activeCategory)
			dispatch({
				type: 'change_category',
				activeCategory: item.slug,
				activeSubChildren: item.slug,
				name: item.Name,
				category: item,
				subChildren: item.children,
			});
	};
	const changeSubCategory = item => {
		if (item.slug !== state.category.slug)
			dispatch({
				type: 'change_sub_category',
				activeSubChildren: item.slug,
				name: `${state.category.Name} | ${item.Name}`,
			});
		else
			dispatch({
				type: 'change_sub_category',
				activeSubChildren: state.category.slug,
				name: `${state.category.Name}`,
			});
	};

	return (
        <div className={styles.brandListMain}>
            <ul className={styles.sidebar}>
				{category.map(item => {
					return getItem(item, 'cat');
				})}
			</ul>
            {state.subChildren.length > 0 && (
				<ul className={styles.sidebar}>
					<li
						onClick={() => changeSubCategory({slug: state.activeCategory})}
						key='all_cat'
						className={
							state.activeCategory === state.activeSubChildren
								? styles.activeItem
								: ''
						}
					>
						<Link href={`/brands/${state.activeCategory}?alpha=A`}>
                            <div className={styles.brandTitle}>All Categories</div>
                        </Link>
					</li>
					{state.subChildren.map(item => {
						return getItem(item, 'child');
					})}
				</ul>
			)}
        </div>
    );
};
export default Categories;
